import {CTA, Container, Breakpoints} from '@volkswagen-onehub/components-core'
import {SizeEnum} from '@volkswagen-onehub/tokens'
import React from 'react'

import {useTranslation} from 'react-i18next'
import {openLegalNotes} from '../../shared/utilities'
import {Download, Info} from '@volkswagen-onehub/icons-core'
import {vehicleTracking} from '../../shared/trackingServiceHelper'
import {Global} from '../../shared/variables'
import {SingleSimulation} from '../../types/SingleSimulation'
import {useSelector} from 'react-redux'
import {RootState} from '../rootReducer'

interface SimulationLinksProps {
    simulationId: number
    index: number
    promoData: SingleSimulation
    legalNotes: string
    configurationCode?: string
}

export function SimulationLinks(
    props: SimulationLinksProps
): React.JSX.Element {
    const {t} = useTranslation('fa-flotte')

    const backendUrl = useSelector(
        (state: RootState) => state.general.backendUrl
    )

    return (
        <>
            <Container
                padding={{
                    top: {
                        [Breakpoints.default]: SizeEnum.static150,
                    },
                    bottom: {
                        [Breakpoints.default]: SizeEnum.static150,
                    },
                }}
                horizontalAlign="flex-start"
                wrap="auto"
                gutter={SizeEnum.static350}
            >
                <CTA
                    tag="button"
                    emphasis="tertiary"
                    onClick={(e: React.MouseEvent): void => {
                        e.preventDefault()
                        openLegalNotes(props.legalNotes)
                        vehicleTracking(
                            Global.LINK,
                            props.promoData.model,
                            props.promoData.version,
                            props.promoData.monthly_payment,
                            window.location.toString(),
                            t('cta.legal'),
                            `${props.promoData.id}-${props.index}`
                        )
                    }}
                    aria-label={t('cta.legal')}
                    icon={<Info aria-hidden />}
                >
                    {t('cta.legal')}
                </CTA>

                {props.configurationCode && (
                    <>
                        <CTA
                            tag="a"
                            emphasis="tertiary"
                            href={`${backendUrl}/${Global.PRINT_URL_CONST}/${props.simulationId}`}
                            target="_blank"
                            onClick={(): void => {
                                vehicleTracking(
                                    Global.LINK,
                                    props.promoData.model,
                                    props.promoData.version,
                                    props.promoData.monthly_payment,
                                    window.location.toString(),
                                    t('cta.pdf'),
                                    `${props.promoData.id}-${props.index}`
                                )
                            }}
                            aria-label={t('cta.pdf')}
                            icon={<Download aria-hidden />}
                        >
                            {t('cta.pdf')}
                        </CTA>
                    </>
                )}
            </Container>
        </>
    )
}
